<div>
  <div class="row">
    <div class="col-6">
      <h6 class="variation">Cart</h6>
    </div>
    <div class="col-6">
      <div class="float-right">
        <!-- <button type="button" class="btn-close" aria-label="Close" (click)="closePopup"></button> -->
      </div>
    </div>
  </div>
  <div class="product-item mt-4">
    @for (item of cartItems; track $index) {
    <hr>

    <div class="row">
      <div class="col-8">
        <h6 class="card-title mb-0">{{ item.name }}</h6>
        <p class="card-text">{{ item.selling_price | currency: '₦'}} - <span class="text-muted">per unit</span> x{{ item.quantity }} Unit@if(item.quantity>1){s}(₦{{ item.selling_price * item.quantity }})</p>
      </div>
      <div class="col-4">
        <div class="row">
          <div class="col-4">
            <button class="btn btn-clear btn-quan btn-xs" [disabled]="item.quantity < 1"
              (click)="decrement(item)">−</button>
          </div>
          <div class="col-4">
            <div class="d-flex align-items-center justify-content-center pt-1">
              <p class="quantity">{{ item.quantity }}</p>
            </div>
          </div>
          <div class="col-4">
            <button class="btn btn-xs btn-quan btn-clear" (click)="increment(item)">+</button>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <hr />
  @if (cartItems.length > 0) {
  <div class="row mt-3">
    <div class="col-6">
      <h5 class="total">Total</h5>
    </div>
    <div class="col-6 text-end">
      <h5 class="amount">₦ {{ getTotalAmount() }}</h5>
    </div>
    <div class="col-md-12">
      <div class="text-center">
        <button class="btn btn-block btn-primary mt-2" (click)="AddToOrder()">Add to Order </button>
      </div>
    </div>
  </div>
  }@else {
    <div class="text-center">
      <div class="">
        <img src="cook.png" alt="">
        <p class="mt-5">
          Your cart is currently empty. Please make an order.
        </p>

      </div>
    </div>
  }
</div>